export type RawDocumentDetails = Record<string, {
    label: string;
    isBackSideRequired: boolean;
  }>;
  
export type UploadDocument = {
    type: string;
    label: string;
    isBackSideRequired: boolean;
};
  
  
export function transformDocumentDetails(details: RawDocumentDetails): UploadDocument[] {
    return Object.entries(details).map(([type, info]) => ({
      type,
      ...info
    }));
}

export const DOCUMENT_TYPE = {
    PASSBOOK: 'PASSBOOK',
    CANCELLED_CHEQUE: 'CANCELLED_CHEQUE',
    BANK_STATEMENT: 'BANK_STATEMENT',
    DL: 'DL',
    OTHER_DOCUMENT: 'OTHER_DOCUMENT',
    ELECTION_CARD: 'ELECTION_CARD',
    PASSPORT: 'PASSPORT',
    VOTER_ID: 'VOTER_ID',
    DRIVING_LICENSE: 'DRIVING_LICENSE',
} as const;


export const getContentType = (fileExtension : string) => {
    switch (fileExtension) {
        case 'pdf':
            return 'application/pdf'
        case 'png':
            return 'image/png'
        case 'jpg':
            return 'image/jpeg'
        case 'jpeg':
            return 'image/jpeg'
        default:
            return 'application/pdf'
    }
}

  